var map = {
	"./App": "3dfd",
	"./App.vue": "3dfd",
	"./assets/Broadsign-logo.png": "ca6e",
	"./assets/Broadsign.png": "cbda",
	"./assets/Finals/3_set/Alcohol_Recall_3_Set.png": "3d87",
	"./assets/Finals/3_set/Automotive_Recall_3_Set.png": "7b3f",
	"./assets/Finals/3_set/CPG_Recall_3_Set.png": "f166",
	"./assets/Finals/3_set/Education_Recall_3_Set.png": "591d",
	"./assets/Finals/3_set/Entertainment_Recall_3_Set.png": "6d88",
	"./assets/Finals/3_set/Fashion_Recall_3_Set.png": "4634",
	"./assets/Finals/3_set/Financial_Recall_3_Set.png": "bf78",
	"./assets/Finals/3_set/Health & Beauty_Recall_3_Set.png": "bd91",
	"./assets/Finals/3_set/Home Improvements_Recall_3_Set.png": "8266",
	"./assets/Finals/3_set/Media_Recall_3_Set.png": "28cd",
	"./assets/Finals/3_set/Real State_Recall_3_Set.png": "165c",
	"./assets/Finals/3_set/Restaurants_Recall_3_Set.png": "30ff",
	"./assets/Finals/3_set/Retail_Recall_3_Set.png": "c63b",
	"./assets/Finals/3_set/Services_Recall_3_Set.png": "1ca2",
	"./assets/Finals/3_set/Telecom_Recall_3_Set.png": "fcad",
	"./assets/Finals/3_set/Travel_Recall_3_Set.png": "29c3",
	"./assets/Finals/3_set/Utilities_Recall_3_Set.png": "9a2d",
	"./assets/Finals/Recall_By_Category.png": "861e",
	"./assets/Finals/Single_Multi_Recall.png": "c797",
	"./assets/Getting_Started_Guide.pdf": "502b",
	"./assets/PattisonLogo.png": "ae2b",
	"./assets/Quebecor_png.png": "9a3e",
	"./assets/broadsign.jpeg": "7a83",
	"./assets/docma-logo-reversed.svg": "dde5",
	"./assets/docma-logo-white-red.svg": "f2af",
	"./assets/footer-hex.svg": "7cd8",
	"./assets/login_background.jpg": "e8fa",
	"./assets/pattison_pptx_background.jpeg": "d8c6",
	"./assets/quebecor-logo.svg": "93ed",
	"./auth": "b628",
	"./auth/": "b628",
	"./auth/authGuard": "3478",
	"./auth/authGuard.js": "3478",
	"./auth/index": "b628",
	"./auth/index.js": "b628",
	"./components/Highlightsv2": "e603",
	"./components/Highlightsv2.vue": "e603",
	"./components/Reporting/DataLevelTable": "f7eb",
	"./components/Reporting/DataLevelTable.vue": "f7eb",
	"./components/Reporting/DateRange": "166a",
	"./components/Reporting/DateRange.vue": "166a",
	"./components/Reporting/ReportingFilterCard": "5905",
	"./components/Reporting/ReportingFilterCard.vue": "5905",
	"./components/Reporting/ReportingFrequencyDistribution": "1a20",
	"./components/Reporting/ReportingFrequencyDistribution.vue": "1a20",
	"./components/Reporting/ReportingHighlights": "bb47",
	"./components/Reporting/ReportingHighlights.vue": "bb47",
	"./components/Reporting/ReportingHighlightsShort": "d5ad",
	"./components/Reporting/ReportingHighlightsShort.vue": "d5ad",
	"./components/Reporting/ReportingMajorHighlight": "6cf4",
	"./components/Reporting/ReportingMajorHighlight.vue": "6cf4",
	"./components/Reporting/ReportingPortfolio": "c903",
	"./components/Reporting/ReportingPortfolio.vue": "c903",
	"./components/Reporting/ReportingReachCurve": "95cd",
	"./components/Reporting/ReportingReachCurve.vue": "95cd",
	"./components/Reporting/TooltipDescription": "487b",
	"./components/Reporting/TooltipDescription.vue": "487b",
	"./components/alerts/SweetSpotError": "7817",
	"./components/alerts/SweetSpotError.vue": "7817",
	"./components/alerts/SweetSpotWarning": "df30",
	"./components/alerts/SweetSpotWarning.vue": "df30",
	"./components/configurationDrawer": "37e9",
	"./components/configurationDrawer.vue": "37e9",
	"./components/configurationSave": "beef",
	"./components/configurationSave.vue": "beef",
	"./components/configurationViewv2": "b2e4",
	"./components/configurationViewv2.vue": "b2e4",
	"./components/dataSelectorDrawerv3": "d773",
	"./components/dataSelectorDrawerv3.vue": "d773",
	"./components/data_viz": "d7d8",
	"./components/data_viz.vue": "d7d8",
	"./components/filterview": "ee75",
	"./components/filterview.vue": "ee75",
	"./components/flighting": "491b",
	"./components/flighting.vue": "491b",
	"./components/frequencyDistrubution": "53b3",
	"./components/frequencyDistrubution.vue": "53b3",
	"./components/profileDrawer": "3a3f",
	"./components/profileDrawer.vue": "3a3f",
	"./components/uniqueReachCurvev3": "39d9",
	"./components/uniqueReachCurvev3.vue": "39d9",
	"./components/uniqueReachCurvev4": "cb8a",
	"./components/uniqueReachCurvev4.vue": "cb8a",
	"./components/userGamification": "6d4e",
	"./components/userGamification.vue": "6d4e",
	"./components/userProfileDrawer": "50ff",
	"./components/userProfileDrawer.vue": "50ff",
	"./components/userProfileEdit": "00d8",
	"./components/userProfileEdit.vue": "00d8",
	"./components/userProfileInfo": "efbe",
	"./components/userProfileInfo.vue": "efbe",
	"./configs/broadsign_config": "f055",
	"./configs/broadsign_config.js": "f055",
	"./configs/docma_config": "476f",
	"./configs/docma_config.js": "476f",
	"./configs/pattison_dev_config": "cfde",
	"./configs/pattison_dev_config.js": "cfde",
	"./configs/pattison_live_config": "225b",
	"./configs/pattison_live_config.js": "225b",
	"./configs/quebecor_dev_config": "bbfe",
	"./configs/quebecor_dev_config.js": "bbfe",
	"./css/broadsign/configDetails.css": "57c1",
	"./css/broadsign/dataSelector.css": "e969",
	"./css/broadsign/gamification.css": "6a8e",
	"./css/broadsign/help.css": "ddb7",
	"./css/broadsign/highlights.css": "a7c9",
	"./css/broadsign/home.css": "6407",
	"./css/broadsign/login.css": "880f",
	"./css/broadsign/profileDrawer.css": "f88e",
	"./css/broadsign/save.css": "4bf8",
	"./css/broadsign/systemFeedback.css": "286f",
	"./css/broadsign/uniqueReachCurveToolTip.css": "6820",
	"./css/docma/configDetails.css": "f7a6",
	"./css/docma/dataSelector.css": "2bba",
	"./css/docma/help.css": "87e9",
	"./css/docma/highlights.css": "4a7a",
	"./css/docma/home.css": "959c",
	"./css/docma/login.css": "c4d5",
	"./css/docma/profileDrawer.css": "d44f",
	"./css/docma/systemFeedback.css": "aaf8",
	"./css/docma/uniqueReachCurveToolTip.css": "1f07",
	"./css/pattison/configDetails.css": "9ac1",
	"./css/pattison/dataSelector.css": "429a",
	"./css/pattison/gamification.css": "7687",
	"./css/pattison/help.css": "4718",
	"./css/pattison/highlights.css": "9802",
	"./css/pattison/home.css": "de6d",
	"./css/pattison/login.css": "7e15",
	"./css/pattison/profileDrawer.css": "8088",
	"./css/pattison/save.css": "8fe7",
	"./css/pattison/systemFeedback.css": "564e",
	"./css/pattison/uniqueReachCurveToolTip.css": "452e",
	"./css/quebecor/configDetails.css": "6b7c",
	"./css/quebecor/dataSelector.css": "79a7",
	"./css/quebecor/gamification.css": "aa50",
	"./css/quebecor/help.css": "956b",
	"./css/quebecor/highlights.css": "e7ad",
	"./css/quebecor/home.css": "4468",
	"./css/quebecor/login.css": "090c",
	"./css/quebecor/profileDrawer.css": "9006",
	"./css/quebecor/save.css": "26f6",
	"./css/quebecor/systemFeedback.css": "757e",
	"./css/quebecor/uniqueReachCurveToolTip.css": "8129",
	"./fonts/GothamBold.otf": "7c6f",
	"./fonts/GothamBold.ttf": "f01e",
	"./fonts/GothamBook.otf": "b9fc",
	"./fonts/GothamBook.ttf": "4f26",
	"./fonts/GothamMedium.otf": "13f8",
	"./fonts/GothamMedium.ttf": "fcad3",
	"./fonts/GothamRegular.otf": "d039",
	"./fonts/Roboto-Black.ttf": "7058",
	"./fonts/Roboto-BlackItalic.ttf": "193d",
	"./fonts/Roboto-Bold.ttf": "5db4",
	"./fonts/Roboto-BoldItalic.ttf": "68a7",
	"./fonts/Roboto-Italic.ttf": "273e",
	"./fonts/Roboto-Light.ttf": "82fe",
	"./fonts/Roboto-LightItalic.ttf": "12c9",
	"./fonts/Roboto-Medium.ttf": "168b",
	"./fonts/Roboto-MediumItalic.ttf": "77c8",
	"./fonts/Roboto-Regular.ttf": "ac8e",
	"./fonts/Roboto-Thin.ttf": "1e8c",
	"./fonts/Roboto-ThinItalic.ttf": "bba6",
	"./fonts/calibri-bold.ttf": "4db3",
	"./fonts/calibri-regular.ttf": "90eb",
	"./fonts/futura-t-bold.ttf": "7c18",
	"./fonts/futura-t-light.ttf": "5cd7",
	"./fonts/futura-t-medium.ttf": "3cd4",
	"./javascript/api_caller": "a0d7",
	"./javascript/api_caller.js": "a0d7",
	"./javascript/api_callers/flighting_api_caller": "fadb",
	"./javascript/api_callers/flighting_api_caller.js": "fadb",
	"./javascript/arrayOperators": "9c32",
	"./javascript/arrayOperators.js": "9c32",
	"./javascript/configurationTree": "d0b2",
	"./javascript/configurationTree.js": "d0b2",
	"./javascript/data": "da6d",
	"./javascript/data.js": "da6d",
	"./javascript/dataSelectorFunctions": "9be8",
	"./javascript/dataSelectorFunctions.js": "9be8",
	"./javascript/data_info": "ac44",
	"./javascript/data_info.js": "ac44",
	"./javascript/exportHelper": "741d",
	"./javascript/exportHelper.js": "741d",
	"./javascript/pdfBuilder": "b2f0",
	"./javascript/pdfBuilder.js": "b2f0",
	"./javascript/pdfBuilder_format2": "f75e",
	"./javascript/pdfBuilder_format2.js": "f75e",
	"./javascript/pdfBuilder_quebecor_format": "0a58",
	"./javascript/pdfBuilder_quebecor_format.js": "0a58",
	"./javascript/pptxBuilder": "5b7c",
	"./javascript/pptxBuilder.js": "5b7c",
	"./javascript/pptxBuilder_format2": "c49e",
	"./javascript/pptxBuilder_format2.js": "c49e",
	"./javascript/pptxBuilder_quebecor_format": "d2f6",
	"./javascript/pptxBuilder_quebecor_format.js": "d2f6",
	"./javascript/reporting_api_caller": "0365",
	"./javascript/reporting_api_caller.js": "0365",
	"./javascript/save_api_caller": "9fa2",
	"./javascript/save_api_caller.js": "9fa2",
	"./javascript/sweetSpotConfiguration": "33ec",
	"./javascript/sweetSpotConfiguration.js": "33ec",
	"./javascript/sweetSpotConfigurationManager": "8dca",
	"./javascript/sweetSpotConfigurationManager.js": "8dca",
	"./javascript/sweetSpotDataManager": "823f",
	"./javascript/sweetSpotDataManager.js": "823f",
	"./main": "56d7",
	"./main.js": "56d7",
	"./plugins/excel-export": "0208",
	"./plugins/excel-export.js": "0208",
	"./plugins/googleCharts": "fc61",
	"./plugins/googleCharts.js": "fc61",
	"./plugins/vuetify": "402c",
	"./plugins/vuetify.js": "402c",
	"./router": "a18c",
	"./router/": "a18c",
	"./router/index": "a18c",
	"./router/index.js": "a18c",
	"./views/Home": "bb51",
	"./views/Home.vue": "bb51",
	"./views/Login": "a55b",
	"./views/Login.vue": "a55b",
	"./views/Login_old": "b3eb",
	"./views/Login_old.vue": "b3eb",
	"./views/Planning": "6859",
	"./views/Planning.vue": "6859",
	"./views/Reporting": "ddc1",
	"./views/Reporting.vue": "ddc1",
	"./views/ServerMaintenance": "3e33",
	"./views/ServerMaintenance.vue": "3e33"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "35a6";